<template>
  <div class="modal-wrapper">
    <transition name="modal" appear>
      <div class="modal">
        <div class="icon close" @click="close">g</div>
        <div class="user-data">
          <div class="avatar">
            <img v-if="currentUser.avatar" :src="`${uploads}/avatars/${currentUser.avatar}`" />
            <span v-else>{{ firstLastLetters }}</span>
          </div>
          <div class="texts">
            <p>{{ currentUser.name }}</p>
            <p>{{ currentUser.company }}</p>
          </div>
        </div>
        <div class="links">
          <router-link :to="`/users/${currentUser._id}`" @click.native="close()">
            <span class="icon">N</span>
            Преглед и редакция на моя профил
          </router-link>
          <a
            @click="
              $store.dispatch('selectCompany', null);
              close();
            "
          >
            <span class="icon">u</span>
            Промяна на фирма от групата на КЦМ
          </a>
          <a @click="logout">
            <span class="icon">g</span>
            Изход от портала
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated']),
    uploads() {
      return process.env.VUE_APP_UPLOADS_URI;
    },
    firstLastLetters() {
      if (this.isAuthenticated) {
        const fullName = this.currentUser.name.split(' ');
        const first = fullName[0].split('')[0];
        const last = fullName.length > 1 ? fullName[fullName.length - 1].split('')[0] : '';

        return `${first + last}`;
      } else return '';
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        if (this.$route.path !== '/') {
          this.close();
          this.$router.push('/');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
.modal-wrapper {
  align-items: center;
  background-color: #102538cc;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 12;
  .modal {
    align-items: center;
    background-color: #fbfbfb;
    border-radius: 10px;
    flex-direction: column;
    display: flex;
    padding: 11px;
    .close {
      align-self: flex-end;
      border-radius: 50%;
      color: #a9b1b5;
      font-size: 35px;
      @include hover();
    }

    .user-data {
      align-items: center;
      display: flex;
      flex-direction: column;
      .avatar {
        align-items: center;
        border: 1px solid #35aadf;
        background: #292d32;
        border-radius: 50%;
        color: #fff;
        display: flex;
        font-size: 40px;
        height: 120px;
        overflow: hidden;
        justify-content: center;
        width: 120px;

        img {
          height: 100%;
          object-fit: cover;
          width: 100%;
        }
      }
      .texts {
        margin-bottom: 3rem;
        margin-top: 8px;
        p {
          color: #004d94;
          text-align: center;
          &:first-child {
            font-size: $px16;
            font-weight: 500;
          }
          &:last-child {
            font-size: $px12;
            opacity: 0.8;
          }
        }
      }
    }
    .links {
      a {
        align-items: center;
        background-color: #effaff;
        border: 2px solid #35aadf;
        border-radius: 10px;
        color: #35aadf;
        cursor: pointer;
        display: flex;
        font-size: $px14;
        font-weight: 500;
        padding: 12px 10px;
        white-space: nowrap;

        &:not(:last-child) {
          margin-bottom: 8px;
        }

        .icon {
          display: inline-block;
          font-size: $px24;
          margin-right: 12px;
        }
      }
    }
  }
}
</style>